import { Items } from "@pdfking/tfunc"

import { is_object } from "./is_object"
import { ordered_object } from "./ordered_object"
import { to_array } from "./to_array"

/**
 * Filters iterable by predicate function.
 *
 * For objects, returns filtered object. For arrays, returns filtered array.
 * Predicate receives (value, key/index).
 *
 * @param f - Predicate function
 * @param iterable - Array, object, or primitive to filter
 * @returns Filtered result matching input type
 *
 * @example
 * ```ts
 * import { filter } from "@pdfking/rfunc"
 *
 * filter(v => v < 3, [1, 2, 3]) // [1, 2]
 * filter(v => v < 3, { a: 2, b: 5 }) // { a: 2 }
 * ```
 */
export const filter = (f, iterable) => {
  if (is_object(iterable)) {
    return ordered_object(Items(iterable).filter(a => f(a[1], a[0])))
  }
  return to_array(iterable).filter(f)
}
